import type { ModuloWeb } from '../../nucleo/modulos-web';
import { Chat } from './Chat';
import { SeloNaoLidas } from './dados';
import { i18n } from './i18n';

/** Fase 2, W15: módulo Equipe (chat da equipe) no menu Comunicação, com o selo de não lidas no item do menu. */
const modulo: ModuloWeb = {
  slug: 'equipe',
  menu: 'comunicacao',
  ordem: 10,
  abas: [{ chave: 'chat', permissao: 'equipe.ver', componente: Chat }],
  seloMenu: SeloNaoLidas,
  i18n,
};

export default modulo;
